var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',{attrs:{"title":_vm.$t('general.exhibitor_edit'),"click-action":_vm.redirect}},[_c('b-icon-people-fill'),_vm._v("  ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }